import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import doneGreen from "../../../public/svgs/done-green.svg";
export interface DoneGreenPropsType {
  className?: React.HTMLAttributes<never>["className"];
}
function DoneGreenIcon(t0) {
  const $ = _c(2);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = <Image className={className} src={doneGreen} alt="done green icon" />;
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default DoneGreenIcon;